var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.048,
    height: 40,
    viewBox: "0 0 46.048 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132503",
    "data-name": "Group 132503",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95936",
    "data-name": "Path 95936",
    d: "M5,40H41.155a4.884,4.884,0,0,0,4.893-4.919V22.616a4.929,4.929,0,0,0-4.893-4.971H39.645L26.373,5.228a3.611,3.611,0,0,0,.359-1.573,3.657,3.657,0,1,0-7.314,0,3.585,3.585,0,0,0,.359,1.568L6.506,17.646H5a5.017,5.017,0,0,0-5,4.971V35.081A4.973,4.973,0,0,0,5,40ZM23.076,1.652a2.009,2.009,0,1,1-2.009,2.009A2.009,2.009,0,0,1,23.076,1.652ZM20.812,6.518a3.617,3.617,0,0,0,4.527,0L37.234,17.646H8.917ZM44.4,35.055a3.3,3.3,0,0,1-3.3,3.3H4.945a3.3,3.3,0,0,1-3.3-3.3V22.59a3.3,3.3,0,0,1,3.3-3.3H41.1a3.3,3.3,0,0,1,3.3,3.3Zm0,0",
    transform: "translate(0)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95937",
    "data-name": "Path 95937",
    d: "M1.025,10.621H2.451V7.594h.61c1.165,0,1.677.544,1.731,1.513.033.577.087,1.176.142,1.513H6.6a3.99,3.99,0,0,1-.348-1.579A2.034,2.034,0,0,0,5.358,7.4,2.171,2.171,0,0,0,6.675,5.286,2.348,2.348,0,0,0,4.3,3H1.025ZM2.451,6.353V4.372h1.72a1.02,1.02,0,0,1,1.067.991,1.02,1.02,0,0,1-1.067.991Zm5.836,4.268h4.649V9.26H9.713V7.344H12.6V5.972H9.713V4.361h3.223V3H8.287Zm6.315,0h1.426V7.083c0-.958-.065-1.753-.065-1.753s.37.708.893,1.5l2.569,3.789h1.208V3H19.207V6.538c0,.969.065,1.764.065,1.764a17.06,17.06,0,0,0-.893-1.513L15.821,3H14.6Zm9.526,0h1.437V4.361H27.7V3h-5.7V4.361h2.134Z",
    transform: "translate(8.961 22.444)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenter);
export default __webpack_public_path__ + "static/media/Renter.4f343e21b048f1e75287df16ae5394ae.svg";
export { ForwardRef as ReactComponent };